import { isAxiosError } from "axios";
import axiosInstance from "../../utility/axiosInstance";
import { toast } from "sonner";

export const cancelSubscription = async () => {
  try {
    const response = await axiosInstance.put("/billing/cancel");

    if (response.data.message) {
      toast.success(response.data.message);
    }

    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
      const errorMessage =
        error?.response?.data?.error?.message ||
        error?.response?.data?.message ||
        "Failed to cancel subscription";
      toast.error(errorMessage);
    }
  }
};

export interface ISubscriptionPayload {
  organizationId: string;
  planId: string;
  frequency: "MONTHLY" | "YEARLY";
  integrationIds: string[];
  deploymentCostIds: string[];
  provider: string;
}

export const subscribeToPlan = async (payload: ISubscriptionPayload) => {
  try {
    const response = await axiosInstance.post("/console/payment/plan", payload);

    if (response.data.message) {
      toast.success(response.data.message);
    }

    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
      const errorMessage =
        error?.response?.data?.error?.message ||
        error?.response?.data?.message ||
        "Failed to subscribe to plan";
      toast.error(errorMessage);
    }
    throw error;
  }
};

export const approvePayment = async (paymentId: string) => {
  try {
    const response = await axiosInstance.post(
      `/billing/approve-payment/${paymentId}`,
    );

    if (response.data.message) {
      toast.success(response.data.message);
    }

    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
      const errorMessage =
        error?.response?.data?.error?.message ||
        error?.response?.data?.message ||
        "Failed to approve payment";
      toast.error(errorMessage);
    }
    throw error;
  }
};

export interface IPaymentReceiptPayload {
  organizationId: string;
  reference: string;
  tier?: string;
  frequency?: string;
  featureIds?: string[];
  amount?: number;
}

export const submitPaymentReceipt = async (payload: IPaymentReceiptPayload) => {
  try {
    const response = await axiosInstance.post(
      "/billing/submit-payment-receipt",
      payload,
    );

    if (response.data.message) {
      toast.success(response.data.message);
    }

    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
      const errorMessage =
        error?.response?.data?.error?.message ||
        error?.response?.data?.message ||
        "Failed to submit payment receipt";
      toast.error(errorMessage);
    }
    throw error;
  }
};

export const sendProgressReport = async (
  organizationId: string,
  reportFile: File,
): Promise<any> => {
  try {
    const formData = new FormData();
    formData.append("organizationId", organizationId);
    formData.append("report", reportFile);

    const response = await axiosInstance.post(
      "/billing/send-progress-report",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );

    if (response.data.message) {
      toast.success(response.data.message);
    }

    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
      const errorMessage =
        error?.response?.data?.error?.message ||
        error?.response?.data?.message ||
        "Failed to send progress report";
      toast.error(errorMessage);
    }
    throw error;
  }
};
